import { useMemo, useState } from 'react';
import { assetUrl } from '../api/client';
import { cx } from '../lib/format';
import { initialsDataUri } from '../lib/avatar';

/**
 * Avatar that renders a real uploaded photo when `photoPath` is set, and
 * gracefully falls back to a generated initials avatar (maroon -> gold brand
 * gradient SVG data URI) when the photo is missing OR fails to load (onError).
 */
export default function InitialsAvatar({ name, photoPath, size = 'lg', fill = false, className = '' }) {
  const [failed, setFailed] = useState(false);
  // In `fill` mode the avatar stretches to fill its parent (e.g. a portrait
  // card) instead of being a fixed circle; render the fallback large + crisp.
  const sizePx = fill ? 512 : { sm: 56, md: 96, lg: 160 }[size] || 160;
  const photoUrl = !failed && photoPath ? assetUrl(photoPath) : null;
  const fallback = useMemo(() => initialsDataUri(name, sizePx), [name, sizePx]);

  return (
    <img
      src={photoUrl || fallback}
      alt={name || 'Member'}
      {...(fill ? {} : { width: sizePx, height: sizePx })}
      loading="lazy"
      onError={() => setFailed(true)}
      className={cx(
        fill ? 'h-full w-full object-cover' : 'aspect-square h-full w-full rounded-full object-cover',
        className
      )}
    />
  );
}
